import { IoSparklesSharp } from 'react-icons/io5'

import { t } from 'i18next'

import Badge from '~/components/Badge'

export const ObjectiveBasedCampaignBadge = ({ goal }: { goal?: Goals }) => (
  <Badge variant="primary" Icon={IoSparklesSharp}>
    {goal
      ? t(`rm:objectiveBased.strategy.${goal}`)
      : t('rm:objectiveBased.campaign')}
  </Badge>
)
